import { BuildUri } from './BuildUri'
import { NetworkManager } from '../context'
import {
    ImageDownscaleCancelResult,
    ImageDownscaleStartResult,
    ImageDownscaleStatus,
} from '../model/Maintenance'

/** Admin-only one-off maintenance jobs. Every call 401s for non-admins. */
class MaintenanceEndpoints {
    /** Starts the background downscale job. `maxDimension` must be 200-4000. */
    startDownscaleImages(
        maxDimension: number
    ): Promise<ImageDownscaleStartResult> {
        return NetworkManager.fetch(
            BuildUri('/maintenance/downscale-images', {}, { maxDimension }),
            { method: 'POST' }
        )
    }

    getDownscaleImagesStatus(): Promise<ImageDownscaleStatus> {
        return NetworkManager.fetch(BuildUri('/maintenance/downscale-images'))
    }

    /** Requests a graceful stop after the image currently being processed. */
    cancelDownscaleImages(): Promise<ImageDownscaleCancelResult> {
        return NetworkManager.fetch(
            BuildUri('/maintenance/downscale-images'),
            { method: 'DELETE' }
        )
    }
}

export default new MaintenanceEndpoints()
